<template>
  <v-toolbar fixed flat color="white">
    <div>
      <v-img :src="require(`../assets/TMX_logo.png`)" height="48" width="101" @click="$router.push('/')" style="cursor: pointer;"/>
    </div>
    <!--v-toolbar-title @click="$router.push('/')" style="cursor: pointer;">
      //
    </v-toolbar-title-->
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <template v-for="(item, index) in $store.state.mainMenu.storeMenu">
        <fragment v-if="!item.children || item.children.length === 0" :key="index">
          <v-btn text @click="item.click()" color="primary">
            {{ $t(`${item.text}`) }}
          </v-btn>
        </fragment>
        <fragment v-else-if="item.children && item.children.length > 0" :key="index">
          <v-menu offset-y transition="scroll-y-transition" open-on-hover>
            <template v-slot:activator="{ on }">
              <v-btn text :key="index" color="primary" v-on="on">
                {{ $t(`${item.text}`) }}
              </v-btn>
            </template>
            <v-list>
              <template v-for="(item, index) in item.children">
                <v-list-item v-show="!(item.text === 'mainNavBar.jobOffers' && $i18n.locale !== 'hu-HU')" :key="index" @click="$router.push(item.path)">
                  <v-list-item-title>
                    {{ $t(`${item.text}`) }}
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </fragment>
      </template>
      <language-change-dropdown />
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import languageChangeDropdown from './languageChangeDropdown.vue';

export default {
  name: 'storeNavBar',
  components: {
    languageChangeDropdown,
  },
  beforeMount() {
    this.lang = this.$i18n.locale;
  },
  data() {
    return {
      lang: '',
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
